// import { ReactComponent as MeiIcon } from "../../../assets/calculadoras/mei.svg";
// import { ReactComponent as AluguelIcon } from "../../../assets/calculadoras/aluguel.svg";
import { ReactComponent as CriptoIcon } from "../../../assets/calculadoras/criptomoedas.svg";
// import { ReactComponent as AutonomosIcon } from "../../../assets/calculadoras/autonomos.svg";
import { ReactComponent as BolsaIcon } from "../../../assets/calculadoras/bolsa-de-valores.svg";
import { ReactComponent as ExteriorIcon } from "../../../assets/calculadoras/ativos-no-exterior.svg";

export const calculadoras = [
  {
    id: "bolsa",
    name: "Bolsa de valores",
    icon: <BolsaIcon />,
  },
  {
    id: "cripto",
    name: "Criptoativos",
    icon: <CriptoIcon />,
  },
  {
    id: "exterior",
    name: "Ativos no exterior",
    icon: <ExteriorIcon />,
  },
  // {
  //   id: "autonomos",
  //   name: "Autônomos",
  //   icon: <AutonomosIcon />,
  // },
  // {
  //   id: "aluguel",
  //   name: "Aluguel",
  //   icon: <AluguelIcon />,
  // },
  // {
  //   id: "mei",
  //   name: "MEI",
  //   icon: <MeiIcon />,
  // },
];
